export class ErrorMessage {
	icon: string;
	title: string;
	message: string;
	input?: string;
	message2?: string;
	action: string;
}

export class ErrorMessages {
	public static getIdentityErrorMessageByCode(code: number): ErrorMessage {
		switch (code) {
			case 1001:
				return {
					icon: 'error-card',
					title: 'Λάθος αριθμός κάρτας ή/και PIN',
					message:
						'Υπάρχει λάθος στον αριθμό της κάρτας ή/και το PIN που πληκτρολογήσατε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 7002:
				return {
					icon: 'error-otp',
					title: 'Σφάλμα στο OTP',
					message: 'Το OTP που πληκτρολογήσατε δεν ισχύει. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 7003:
				return {
					icon: 'error-chances-2',
					title: 'Φτάσατε στο μέγιστο αριθμό προσπαθειών',
					message:
						'Για την ασφάλειά σας δεν μπορείτε να πληκτρολογήσετε ξανά το OTP. Για να προχωρήσετε παρακαλούμε επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 7004:
				return {
					icon: 'error-otp',
					title: 'Πληκτρολογήστε νέο OTP',
					message:
						'Για την ασφάλειά σας δεν μπορείτε να πληκτρολογήσετε ξανά το OTP. Για να προχωρήσετε παρακαλούμε επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 6001:
				return {
					icon: 'error-otp-4',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Η διαδικασία σύνδεσης με OTP απέτυχε. Παρακαλούμε βεβαιωθείτε πως στη συσκευή σας επιτρέπεται η αποθήκευση cookies και δοκιμάστε ξανά.',
					action: 'Εντάξει',
				};
			case 6002:
				return {
					icon: 'error-otp',
					title: 'Σφάλμα στο OTP',
					message: 'Το OTP που πληκτρολογήσατε δεν ισχύει. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			default:
				break;
		}
	}

	public static getOnboardingErrorMessageByCode(code: number): ErrorMessage {
		switch (code) {
			case 1012:
				return {
					icon: 'error-branch',
					title: 'Χρειαζόμαστε το κινητό σας τηλέφωνο',
					message:
						'Για να προχωρήσετε χρειάζεται να επισκεφτείτε ένα κατάστημά μας και να δηλώσετε τον αριθμό του κινητού σας τηλεφώνου. ',
					action: 'Ενημερώθηκα',
				};
			case 1015:
				return {
					icon: 'error-personal-data',
					title: 'Χρειαζόμαστε τα προσωπικά σας στοιχεία',
					message:
						'Η έκδοση των κωδικών σας δεν μπορεί να ολοκληρωθεί καθώς δεν είναι καταχωρημένα κάποια στοιχεία σας. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας.',
					action: 'Ενημερώθηκα',
				};
			case 1016:
				return {
					icon: 'error-personal-data',
					title: 'Χρειαζόμαστε τα προσωπικά σας στοιχεία',
					message:
						'Η έκδοση των κωδικών σας δεν μπορεί να ολοκληρωθεί καθώς δεν είναι καταχωρημένα κάποια στοιχεία σας. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας.',
					action: 'Ενημερώθηκα',
				};
			case 1017:
				return {
					icon: 'error-id',
					title: 'Χρειαζόμαστε την ταυτότητά σας',
					message:
						'Η έκδοση κωδικών δε μπορεί να ολοκληρωθεί γιατί δεν είναι καταχωρημένη η ταυτότητά σας. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας για να την προσκομίσετε.',
					action: 'Ενημερώθηκα',
				};
			case 1018:
				return {
					icon: 'error-afm',
					title: 'Χρειαζόμαστε το ΑΦΜ σας',
					message:
						'Η έκδοση κωδικών δε μπορεί να ολοκληρωθεί γιατί δεν είναι καταχωρημένο το ΑΦΜ σας. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας για να προσκομίσετε έγγραφο που το βεβαιώνει.',
					action: 'Ενημερώθηκα',
				};
			case 1021:
				return {
					icon: 'error-chances-4',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά και αν το πρόβλημα παραμένει επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 1025:
				return {
					icon: 'error-personal-data-2',
					title: 'Χρειαζόμαστε κάποια ακόμα προσωπικά σας στοιχεία',
					message:
						'Η έκδοση των κωδικών σας δεν μπορεί να ολοκληρωθεί καθώς δεν είναι καταχωρημένα κάποια στοιχεία σας. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας.',
					action: 'Ενημερώθηκα',
				};
			case 5013:
				return {
					icon: 'error-branch',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας για την έκδοση των κωδικών σας. ',
					action: 'Ενημερώθηκα',
				};
			case 1020:
				return {
					icon: 'error-branch',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε επισκεφτείτε ένα κατάστημά μας για την έκδοση των κωδικών σας. ',
					action: 'Ενημερώθηκα',
				};
			case 4009:
				return {
					icon: 'error-email-2',
					title: 'Κάτι δεν πήγε καλά με το email',
					message:
						'Παρακαλούμε προσπαθήστε ξανά σε 24 ώρες χρησιμοποιώντας ένα διαφορετικό email.',
					action: 'Εντάξει',
				};
			case 4019:
				return {
					icon: 'error-4',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Συγνώμη αλλά κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά, και αν το πρόβλημα παραμένει επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 5004:
				return {
					icon: 'error-email',
					title: 'Κάτι δεν πήγε καλά με το email',
					message: 'Παρακαλούμε καταχωρίστε ξανά ένα έγκυρο email στο αντίστοιχο βήμα.',
					action: 'Εντάξει',
				};
			case 60011:
				return {
					icon: 'error-otp',
					title: 'Ο κωδικός επιβεβαίωσης δεν επαληθεύτηκε',
					message:
						'Έγινε κάποιο λάθος στον κωδικό επιβεβαίωσης. Παρακαλούμε πληκτρολογήστε τον ξανά. ',
					action: 'Εντάξει',
				};
			case 60012:
				return {
					icon: 'error-chances-3',
					title: 'Φτάσατε στο μέγιστο αριθμό προσπαθειών',
					message:
						'Για την ασφάλειά σας δεν μπορείτε να πληκτρολογήσετε ξανά τον κωδικό επιβεβαίωσης. Παρακαλούμε προσπαθήστε ξανά μετά από 1 ώρα.',
					action: 'Εντάξει',
				};
			case 60013:
				return {
					icon: 'error-otp-5',
					title: 'Ο κωδικός επιβεβαίωσης έχει λήξει.',
					message: 'Παρακαλούμε επιλέξτε "Αποστολή ξανά" ώστε να σας σταλεί νέος.',
					action: 'Εντάξει',
				};
			case 60014:
				return {
					icon: 'error-chances-3',
					title: 'Φτάσατε στο μέγιστο αριθμό προσπαθειών',
					message:
						'Για την ασφάλειά σας δεν μπορείτε να πληκτρολογήσετε ξανά τον κωδικό επιβεβαίωσης. Παρακαλούμε προσπαθήστε ξανά μετά από 1 ώρα.',
					action: 'Εντάξει',
				};
			case 7004:
				return {
					icon: 'error-email-2',
					title: 'Κάτι δεν πήγε καλά με το email',
					message:
						'Παρακαλούμε προσπαθήστε ξανά σε 24 ώρες χρησιμοποιώντας ένα διαφορετικό email.',
					action: 'Εντάξει',
				};
			default:
				break;
		}
	}

	public static getIdentityErrorMessageByDesc(desc: string): ErrorMessage {
		switch (desc) {
			case 'system-error':
				return {
					icon: 'error-technical',
					title: 'Παρουσιάστηκε τεχνικό σφάλμα',
					message:
						'Δυστυχώς κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'Authentication process is not initialized.':
				return {
					icon: 'error-technical',
					title: 'Παρουσιάστηκε τεχνικό σφάλμα',
					message:
						'Δυστυχώς κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'Service Unavailable':
				return {
					icon: 'error-cloud',
					title: 'Προσωρινά μη διαθέσιμη υπηρεσία ',
					message:
						'Λυπούμαστε, αλλά αυτή τη στιγμή η υπηρεσία δεν είναι διαθέσιμη. Παρακαλούμε προσπαθήστε ξανά αργότερα.',
					action: 'Εντάξει',
				};
			case 'Invalid OTP.':
				return {
					icon: 'error-otp',
					title: 'Λάθος OTP',
					message: 'Παρακαλούμε επιλέξτε την αποστολή νέου OTP και προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'Invalid code':
				return {
					icon: 'error-otp',
					title: 'Σφάλμα στον κωδικό επιβεβαίωσης',
					message:
						'Παρακαλούμε βεβαιωθείτε πως ο κωδικός επιβεβαίωσης είναι σωστός και πληκτρολογήστε τον ξανά.',
					action: 'Εντάξει',
				};
			case 'Incorrect Verification Code':
				return {
					icon: 'error-otp',
					title: 'Σφάλμα στον κωδικό επιβεβαίωσης',
					message:
						'Παρακαλούμε βεβαιωθείτε πως ο κωδικός επιβεβαίωσης είναι σωστός και πληκτρολογήστε τον ξανά.',
					action: 'Εντάξει',
				};
			case 'Max number of verification retries exceeded.':
				return {
					icon: 'error-chances',
					title: 'Φτάσατε στο μέγιστο αριθμό προσπαθειών',
					message:
						'Για την ασφάλειά σας, δεν μπορείτε να πληκτρολογήσετε άλλο κωδικό επιβεβαίωσης. Παρακαλούμε δοκιμάστε ξανά αργότερα',
					action: 'Εντάξει',
				};
			case 'Verification code has expired':
				return {
					icon: 'error-otp-5',
					title: 'Ο κωδικός επιβεβαίωσης έχει λήξει',
					message: 'Παρακαλούμε επιλέξτε την αποστολή νέου κωδικού και προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'Invalid UserId.':
				return {
					icon: 'error-username',
					title: 'Κάτι δεν πήγε καλά με το username',
					message:
						'To username που πληκτρολογήσατε δεν αναγνωρίστηκε. Παρακαλούμε ελέγξτε το και προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'OTP maximum retries reached.':
				return {
					icon: 'error-chances-2',
					title: 'Φτάσατε στο μέγιστο αριθμό προσπαθειών',
					message:
						'Δεν μπορείτε να πληκτρολογήσετε ξανά το OTP. Για να προχωρήσετε παρακαλούμε επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 'Unrecognized OTP error.':
				return {
					icon: 'error-otp-2',
					title: 'Σφάλμα στην αποστολή OTP',
					message:
						'Παρουσιάστηκε σφάλμα κατά τη διαδικασία αποστολής OTP. Για να προχωρήσετε παρακαλούμε επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 'Problematic OTP device.':
				return {
					icon: 'error-branch',
					title: 'Χρειαζόμαστε το κινητό σας τηλέφωνο',
					message:
						'Για να προχωρήσετε χρειάζεται να επισκεφτείτε ένα κατάστημά μας και να δηλώσετε τον αριθμό του κινητού σας τηλεφώνου.',
					action: 'Ενημερώθηκα',
				};
			case 'OTP is already used.':
				return {
					icon: 'error-otp',
					title: 'Πληκτρολογήστε νέο OTP',
					message:
						'Το OTP που εισαγάγατε έχει ξαναχρησιμοποιηθεί. Παρακαλούμε δοκιμάστε ξανά με νέο OTP.',
					action: 'Εντάξει',
				};
			case 'credentials-error':
				return {
					icon: 'error',
					title: 'Σφάλμα στο username ή στο password',
					message:
						'Το username ή/και το password που πληκτρολογήσατεδεν είναι σωστό. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Ενημερώθηκα',
				};
			case 'Invalid Credentilas':
				return {
					icon: 'error-card',
					title: 'Λάθος αριθμός κάρτας ή/και PIN',
					message:
						'Υπάρχει λάθος στον αριθμό της κάρτας ή/και το PIN που πληκτρολογήσατε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'OldPasswordWentWrong':
				return {
					icon: 'error-username',
					title: 'Το password που πληκτρολογήσατε δεν αναγνωρίστηκε. Παρακαλούμε προσπαθήστε ξανά.',
					message:
						'Υπάρχει λάθος στον αριθμό της κάρτας ή/και το PIN που πληκτρολογήσατε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'invalid-userLevel':
				return {
					icon: 'error-user-with-no-rights',
					title: 'Οι κωδικοί σας δεν είναι έγκυροι',
					message:
						'Για να μπορέσετε να συνδεθείτε, παρακαλούμε επικοινωνήστε με το νόμιμο εκπρόσωπο της εταιρίας σας.',
					action: 'Ενημερώθηκα',
				};
			default:
				break;
		}
	}

	public static getGeneralErrorMessage(generalError: string): ErrorMessage {
		switch (generalError) {
			case 'onboardInternetBanking':
				return {
					icon: 'error-4',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Συγνώμη αλλά κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά, και αν το πρόβλημα παραμένει επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Ενημερώθηκα',
				};
			case 'general':
				return {
					icon: 'error-2',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Συγνώμη αλλά κάτι δεν πήγε καλά και η διαδικασία διακόπηκε. Παρακαλούμε προσπαθήστε ξανά.',
					action: 'Εντάξει',
				};
			case 'general2FAErrors':
				return {
					icon: 'error-3',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Παρουσιάστηκε κάποιο σφάλμα κατά τη διαδικασία σύνδεσης με χρήση OTP. Παρακαλούμε δοκιμάστε ξανά αργότερα.',
					action: 'Εντάξει',
				};

			case 'generalOtpErrors':
				return {
					icon: 'error-otp-3',
					title: 'Κάτι δεν πήγε καλά',
					message:
						'Παρουσιάστηκε κάποιο σφάλμα κατά τον έλεγχο του OTP. Για να προχωρήσετε παρακαλούμε επικοινωνήστε μαζί μας στο τηλέφωνο 210 4848484.',
					action: 'Εντάξει',
				};
			default:
				break;
		}
	}
}
